import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=3c834049"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=3c834049&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports